import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/Header";

export default function BaseLocationSettings() {
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [address, setAddress] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocation = async () => {
      const token = sessionStorage.getItem("token");
      const res = await axios.get("/api/map/user/base-location", {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLat(res.data.lat);
      setLng(res.data.lng);
      setAddress(res.data.address || "");
    };
    fetchLocation();
  }, []);

  const handleGeocodeAndSave = async () => {
  if (!address.trim()) {
    alert("住所を入力してください");
    return;
  }

  try {
    const geoRes = await axios.get("https://maps.googleapis.com/maps/api/geocode/json", {
      params: {
        address,
        key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      }
    });

    if (geoRes.data.status !== "OK" || !geoRes.data.results.length) {
      alert("住所が見つかりません。正しい住所を入力してください。");
      return;
    }

    const loc = geoRes.data.results[0].geometry.location;

    const token = sessionStorage.getItem("token");
    await axios.put("/api/map/user/base-location", {
      lat: loc.lat,
      lng: loc.lng,
      address: address.trim()
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setLat(loc.lat);
    setLng(loc.lng);
    
    alert("出発地点を更新しました！");
  } catch (err) {
    const message = err.response?.data?.error || "保存に失敗しました。もう一度お試しください。";
    alert("エラー: " + message);
  }
};


  return (
  <>
      <Header />
    <Box p={2}>
      <Typography variant="h6">出発地点の設定</Typography>
      {address ? (
    <Typography variant="body2">現在の出発地点：{address}</Typography>
  ) : (
    <Typography variant="body2" color="text.secondary">
      出発地点はまだ設定されていません
    </Typography>
  )}
      <Box mt={2}>
        <input
          type="text"
          placeholder="例：○○県◯◯市◯◯"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          style={{ width: "100%", padding: "8px", marginBottom: "8px" }}
        />
        <Button variant="contained" color="primary" onClick={handleGeocodeAndSave}>
          設定して保存
        </Button>
      </Box>
      <Box mt={2}>
</Box>
<Button
  variant="outlined"
  fullWidth
  sx={{ mt: 3 }}
  onClick={() => navigate("/map-route")}
>
  ← ルート画面に戻る
</Button>
    </Box>
    </>
  );
}
